import React from "react";
import ExecutiveSummary from "./containers/ExecutiveSummary/ExecutiveSummary";
import Footer from "./containers/Footer/Footer";
import Header from "./containers/Header/Header";
import AI from "./containers/AI/AI";
import Roadmap from "./containers/Roadmap/Roadmap";
import Team from "./containers/Team/Team";
import TopSection from "./containers/TopSection/TopSection";
import UseCases from "./containers/UseCases/UseCases";
const App = () => {
    return (
        <main>
            <Header/>
            <TopSection/>
            <ExecutiveSummary/>
            <AI/>
            <UseCases/>
            <Roadmap/>
            <Team/>
            <Footer/>
        </main>
    );
    
};

export default App;
